module.exports = __webpack_public_path__ + "static/media/Transversalidad.f8045ca1.png";